import user from '@/store/modules/user'
const NOTIFICATIONS_KEY_PREFIX = 'recordId'
import Base64 from 'crypto-js/enc-base64'
import hmacSHA256 from 'crypto-js/hmac-sha256'

const getNotificationsByRecordsId = function (ids) {
  const query = {
    query: `query { ${ids.reduce((prev, current) => {
      return prev.concat(`${NOTIFICATIONS_KEY_PREFIX}${current}:notifications(topics: ["quotes:${current}"]) { unreadCount }`)
    }, '')} }`}
  const req = new Request('https://api.magicbell.com/graphql', {
    method: 'POST',
    headers: {
      'X-MAGICBELL-API-KEY': import.meta.env.VITE_APP_MAGICBELL_API_KEY,
      'X-MAGICBELL-USER-HMAC': Base64.stringify(
        hmacSHA256(
          user.state.currentUser?.externalId,
          import.meta.env.VITE_MAGICBELL_API_SECRET,
        ),
      ),
      'X-MAGICBELL-USER-EXTERNAL-ID': user.state.currentUser?.externalId,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(query),
  })
  return fetch(req).then(async (response) => {
    const { data: notifications } = await response.clone().json()
    return Object.entries(notifications).reduce((prev, [key, value]) => ({
      ...prev,
      [key.replace(NOTIFICATIONS_KEY_PREFIX, '')]: value.unreadCount,
    }), {})
  })
}

const markRecordNotificationsAsReed = (recordId) => {
  const req = new Request(`https://api.magicbell.com/notifications/read?topics=quotes:${recordId}`, {
    method: 'POST',
    headers: {
      'X-MAGICBELL-API-KEY': import.meta.env.VITE_APP_MAGICBELL_API_KEY,
      'X-MAGICBELL-USER-HMAC': Base64.stringify(
        hmacSHA256(
          user.state.currentUser?.externalId,
          import.meta.env.VITE_MAGICBELL_API_SECRET,
        ),
      ),
      'X-MAGICBELL-USER-EXTERNAL-ID': user.state.currentUser?.externalId,
      'Content-Type': 'application/json',
    },
  })

  return fetch(req)
}

export default {
  getNotificationsByRecordsId,
  markRecordNotificationsAsReed,
}
